import { apiFetch } from './api';

export interface Task {
  id: number;
  lehrer_id: number;
  titel: string;
  beschreibung: string | null;
  faellig_am: string | null;
  erledigt: 0 | 1;
  erledigt_am: string | null;
  quelle: 'manuell' | 'diktat' | 'radar' | 'mail' | 'gespraech' | 'klassenarbeit';
  quelle_ref_id: string | null;
  quelle_ref_typ: 'diktat_aktion' | 'mail_message' | 'radar' | 'gespraech' | 'schultermin' | null;
  prioritaet: 'normal' | 'hoch';
  schueler_id: number | null;
  klasse_id: number | null;
  // Join-Felder (GET /api/tasks) — optional
  schueler_vorname?: string | null;
  schueler_nachname?: string | null;
  klasse_name?: string | null;
  gespraech_datum?: string | null;   // Welle Z3: „aus Gespräch vom TT.MM.“
  created_at: string;
  updated_at: string;
}

export interface TasksResponse {
  tasks: Task[];
  gruppen: {
    ueberfaellig: Task[];
    heute:        Task[];
    diese_woche:  Task[];
    spaeter:      Task[];
    undatiert:    Task[];
    erledigt:     Task[];
  };
}

// Welle S4b: lokaler Fetch-Klon entfernt — zentraler apiFetch aus lib/api
export const tasksApi = {
  laden: (includeArchived = false) =>
    apiFetch<TasksResponse>(`/api/tasks${includeArchived ? '?include_archived=1' : ''}`),

  erstellen: (payload: {
    titel: string;
    beschreibung?: string;
    faellig_am?: string;
    quelle?: string;
    quelle_ref_id?: string;
    quelle_ref_typ?: string;
    prioritaet?: 'normal' | 'hoch';
    schueler_id?: number | null;
    klasse_id?: number | null;
  }) =>
    apiFetch<{ task: Task }>('/api/tasks', {
      method: 'POST', body: JSON.stringify(payload),
    }),

  aktualisieren: (id: number, patch: Partial<Pick<Task, 'titel' | 'beschreibung' | 'faellig_am' | 'erledigt' | 'prioritaet' | 'schueler_id' | 'klasse_id'>>) =>
    apiFetch<{ task: Task }>(`/api/tasks/${id}`, {
      method: 'PATCH', body: JSON.stringify(patch),
    }),

  loeschen: (id: number) =>
    apiFetch<{ ok: boolean }>(`/api/tasks/${id}`, { method: 'DELETE' }),
};
